import axios from "axios";

// const CancelToken = axios.CancelToken;
// let cancelTokens = [];

// API SERVER
const serverAddr = process.env.REACT_APP_NETWORK_ADDR;

// function to add a new cancel token
// function addCancelToken() {
//   const source = CancelToken.source();
//   cancelTokens.push(source);
//   return source.token;
// }

// Function to cancel all ongoing requests
// function cancelAllRequests() {
//   cancelTokens.forEach((source) => { console.log("soure", source); source.cancel("Request canceled due to error in one of the requests") });
//   cancelTokens = []; // Reset after canceling
// }

const NETWORK_CONFIG = axios.create({
  baseURL: serverAddr,
  timeout: 300000,
  headers: {},
  withCredentials: true,
  // cancelToken: addCancelToken(),      //add cancel token to each request
  transformRequest: [
    function (data, headers) {
      const access_token = window.localStorage.getItem("access_token");
      if (access_token) {
        headers["Authorization"] = "Bearer " + access_token;
      }
      headers["Content-Type"] = "application/json;charset=UTF-8";
      return JSON.stringify(data);
    },
  ],

  transformResponse: [
    function (data) {
      data = JSON.parse(data);
      if (!data.status && data.redirect == '/') {      //if anything fails and got redirect in the api
        console.log("request failed");

        // cancelAllRequests(); // cancel all requests if there’s an error

        // handleRequestError(data);   //handle error and redirects

        localStorage.clear();

        window.location.replace("/");

        return;
      }

      setToken(data);     //set all tokens

      // if (!data.status && data.validation) {      //just to show validation - without validation
      //   console.log("request validation failed");
      // }

      return data;
    },
  ],
});


// // axios interceptor - gets call on each request and checks if current token is expired. if expired then get new token and store it somewhere
// NETWORK_CONFIG.interceptors.request.use(async (req) => {
//   let expires_in = window.localStorage.getItem("expire_in");
//   const is_expired = new Date() > new Date(expires_in);

//   if (!is_expired || !expires_in) return req;

//   if (window.localStorage.getItem("refresh_token") || expires_in) {
//     console.log("token time expired");


//     cancelAllRequests(); // cancel all requests if there’s an error


//     localStorage.clear();
//     location.reload(true);
//     router.push({ path: data.redirect || '/login' });

//     // return axios
//     //   .post(${serverAddr}/auth/v1/obtain_access_token, {
//     //     refresh_token: window.localStorage.getItem("refresh_token"),
//     //   })
//     //   .then(function (response) {
//     //     if (response.status == 200 && "token_data" in response.data) {

//     //       setToken(response.data);    //set all tokens

//     //       req.headers["Authorization"] = "Bearer " + response.data["token_data"]["access_token"];

//     //       return req;
//     //     } else {
//     //       handleRequestError({});   //handle error and redirects
//     //     }
//     //   })
//     //   .catch(function (err) {
//     //     console.log("err", err);
//     //     handleRequestError({});   //handle error and redirects
//     //   });
//   }
// });


// axios interceptor - gets call on each request and checks if current token is expired. if expired then get new token and store it somewhere
// NETWORK_CONFIGForChat.interceptors.request.use(async (req) => {
//   let expires_in = window.localStorage.getItem("expire_in");
//   const is_expired = new Date() > new Date(expires_in);

//   if (!is_expired || !expires_in) return req;

//   if (window.localStorage.getItem("refresh_token") || expires_in) {
//     console.log("token time expired");


//     cancelAllRequests(); // cancel all requests if there’s an error


//     localStorage.clear();
//     location.reload(true);
//     router.push({ path: data.redirect || '/login' });

//     // return axios
//     //   .post(${serverAddr}/auth/v1/obtain_access_token, {
//     //     refresh_token: window.localStorage.getItem("refresh_token"),
//     //   })
//     //   .then(function (response) {
//     //     if (response.status == 200 && "token_data" in response.data) {

//     //       setToken(response.data);    //set all tokens

//     //       req.headers["Authorization"] = "Bearer " + response.data["token_data"]["access_token"];

//     //       return req;
//     //     } else {
//     //       handleRequestError({});   //handle error and redirects
//     //     }
//     //   })
//     //   .catch(function (err) {
//     //     console.log("err", err);
//     //     handleRequestError({});   //handle error and redirects
//     //   });
//   }
// });

function setToken(data) {
  if ("token_data" in data) {
    if ("access_token" in data.token_data) {
      window.localStorage.setItem("access_token", data["token_data"]["access_token"]);
    }

    if ("refresh_token" in data.token_data) {
      window.localStorage.setItem("refresh_token", data["token_data"]["refresh_token"]);
    }
  }

  if ("expire_in" in data) {
    window.localStorage.setItem("expire_in", data["expire_in"]);
  }
};

/* ---------- GENERIC METHODS ---------- */
export const apiGet = (url) => {
  return NETWORK_CONFIG.get(url);
};

export const apiPost = (url, data = {}) => {
  return NETWORK_CONFIG.post(url, data);
};